export default "__VITE_ASSET__BUsl0aPO__"